import { DataBean } from "../../DataBean";


export class PharmaCumState extends DataBean {

    public async getPharmaCumStateCatalog(regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getPharmaCumStateCatalog_String_Number_Number", [regexStr, page, recordsPerPage]);
    }

}